module.exports = __webpack_public_path__ + "static/img/daiyunying_goutong.10df0e5f.png";